import {Companies} from "./models.js";

function CompanyLog(month, year) {

    // Integer
    const value = null;
    const realYear = null;

    // Strings
    const text = null;
    const type = null;
    const eventName = null;

    // Foreign keys
    const companyId = null;

    return {
        month,
        year,
        value,
        realYear,
        text,
        type,
        eventName,
        companyId,
    };
}

function getCompanyLogCompany(companyLog) {
    return Companies.find({'$loki': companyLog.companyId})[0];
}

export { CompanyLog, getCompanyLogCompany }
